import { render } from "./PortfolioNavigationItem.vue?vue&type=template&id=d09030d0&scoped=true"
import script from "./PortfolioNavigationItem.vue?vue&type=script&lang=js"
export * from "./PortfolioNavigationItem.vue?vue&type=script&lang=js"

import "./PortfolioNavigationItem.vue?vue&type=style&index=0&id=d09030d0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d09030d0"],['__file',"src/scripts/view/portfolio/sections/common/navigation/PortfolioNavigationItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d09030d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d09030d0', __exports__)) {
    api.reload('d09030d0', __exports__)
  }
  
  module.hot.accept("./PortfolioNavigationItem.vue?vue&type=template&id=d09030d0&scoped=true", () => {
    api.rerender('d09030d0', render)
  })

}


export default __exports__